export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./editStaff.vue?vue&type=template&id=c1c89cf4&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/editStaff.vue?vue&type=template&id=c1c89cf4&
// module id = 1363
// module chunks = 0